import { disableCalendar, enableCalendar } from '../components/calendar'
import { htmlIded } from '../fun-js-lib/html'
import { isContentFilledCorrectly, onInputInContent } from './content'
import { addHint, changeHint, contentHint } from './hint'

export function initValidateNavigation () {
  addHints()
  onInputInContent(validate)
  validate()
}

function validate () {
  if (isContentFilledCorrectly()) {
    htmlIded('close-button-content').innerHTML = 'Izađi'
    enableNavigation()
  } else {
    htmlIded('close-button-content').innerHTML = 'Izađi bez čuvanja'
    disableNavigation()
  }
}

function addHints () {
  addHint(bigPrevious(), '', 'right')
  addHint(bigNext(), '', 'left')
  addHint(first(), '', 'bottom')
  addHint(smallPrevious(), '', 'bottom')
  addHint(smallNext(), '', 'bottom')
  addHint(last(), '', 'bottom')
  addHint(calendar(), '', 'left')
}

function enableNavigation () {
  enableCalendar()
  changeHint(bigPrevious(), 'Prethodna')
  changeHint(bigNext(), 'Sledeća')
  changeHint(first(), 'Prva')
  changeHint(smallPrevious(), 'Prethodna')
  changeHint(smallNext(), 'Sledeća')
  changeHint(last(), 'Poslednja')
  changeHint(calendar(), 'Pronađi stranu')

  bigPrevious().setAttribute('href', previousRoute())
  bigNext().setAttribute('href', nextRoute())
  first().setAttribute('href', firstRoute())
  smallPrevious().setAttribute('href', previousRoute())
  smallNext().setAttribute('href', nextRoute())
  last().setAttribute('href', lastRoute())
}

function disableNavigation () {
  disableCalendar()
  changeHint(bigPrevious(), contentHint)
  changeHint(bigNext(), contentHint)
  bigPrevious().removeAttribute('href')
  bigNext().removeAttribute('href')

  small().forEach(element => {
    changeHint(element, contentHint)
    element.removeAttribute('href')
  })

  changeHint(calendar(), contentHint)
}

const bigPrevious = () => htmlIded('big-navigation-arrow-previous')

const bigNext = () => htmlIded('big-navigation-arrow-next')

const first = () => htmlIded('first-page-arrow')

const smallPrevious = () => htmlIded('previous-page-small-arrow')

const smallNext = () => htmlIded('next-page-small-arrow')

const last = () => htmlIded('last-page-arrow')

const calendar = () => htmlIded('date-search')

const previousRoute = () => htmlIded('previous-page-route').innerHTML

const nextRoute = () => htmlIded('next-page-route').innerHTML

const firstRoute = () => htmlIded('first-page-route').innerHTML

const lastRoute = () => htmlIded('last-page-route').innerHTML

const small = () => [
  first(),
  smallPrevious(),
  smallNext(),
  last()
]